<template>
  <div>
    <div class="common-select">
      <van-field
        class="answer-input"
        v-model="selectValue"
        readonly
        @click="bindClick"
      />
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      selectValue: '',
      showPicker: false,
      columns: []
    }
  },
  watch: {
    'data.id'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.columns = this.data.options.map((item) => {
        if (this.data.value == item.key) {
          this.selectValue = item.value
        }
        return {
          text: item.value,
          value: item.key
        }
      })
    },
    bindClick() {
      this.showPicker = true
    },
    onConfirm(item) {
      this.selectValue = item.text
      this.$emit('change', item.value)
      this.showPicker = false
    }
  }
}
</script>
<style lang="scss" scoped>
.common-select {
  margin-top: 25vh;
}

.answer-input {
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid #f1f1f1;
}

.text {
  text-align: center;
  margin-top: 30px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

.my-swipe {
  margin-top: 20px;

  .swiper-image-item {
    width: 100%;
  }
}
</style>
